import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import {articleDetail} from '@/api/server/article'

import Banner from '@/components/Banner'
import Contact from '@/components/Contact'

export default {
  name: 'NoticeDetailPage',
  mixins: [commonMixin],
  data () {
    return {
      _id: 0,
      info: null
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    Banner,
    Contact
  },
  computed: {
  },
  methods: {
    _getDetail () {
      let query = {
        id: this._id
      }
      articleDetail(query).then( (res) => {
        if (res.code === 200) {
          this.info = res.data
        }
      })
    },
    reset () {
      this.info = null
      this._getDetail()
    },
    handleRoute (route) {
      if (route.name === 'article-detail') {
        this._id = this.$route.query.id
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}